export { default } from "ember-stereo/-private/helpers/is-helper";
